// src/tasks/index.js — екран „Задачи" (Фаза 3.2). Пренесен дословно от app.js;
// legacy таблото вика window.taskForm — публикува се най-долу.

import { el, clear, $, field, input, row, clickableRow } from '../shared/dom.js';
import { dateInput, localTodayIso, guardDates } from '../shared/dates.js';
import { dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { panelHead, emptyState, loadError } from '../shared/ui.js';
import { openModal, closeModal, confirmDialog } from '../shared/modal.js';
import { state, cq, isAdminUser } from '../shared/state.js';

export async function view(page) {
  clear(page);
  if (!state().activeCompany) return window.CRM.needsCompany(page);
  let tasks = [];
  try { tasks = await api('/tasks' + cq()); }
  catch (e) { page.appendChild(loadError(() => view(page))); return; }
  const panel = el('div', { class: 'panel' });
  panel.appendChild(panelHead('Задачи и напомняния', 'Нова задача', () => taskForm()));
  const wrap = el('div');
  const open = tasks.filter((t) => !t.done).sort((a, b) => (a.due_date || '9999').localeCompare(b.due_date || '9999'));
  const done = tasks.filter((t) => t.done);
  if (!tasks.length) wrap.appendChild(emptyState('✔', 'Още няма задачи.', '+ Нова задача', () => taskForm()));
  else {
    const tb = el('tbody');
    const today = localTodayIso();
    const addRow = (t) => {
      const overdue = !t.done && t.due_date && t.due_date < today;
      const cb = el('input', { type: 'checkbox', checked: t.done, onClick: async (e) => { e.stopPropagation(); try { await api('/tasks/' + t.id + '/done', { method: 'PATCH', body: JSON.stringify({ done: e.target.checked }) }); view($('#page')); } catch (err) { toast(err.message, true); } } });
      tb.appendChild(clickableRow(() => taskForm(t), 'Отвори задача: ' + t.title,
        el('td', { style: 'width:36px', onClick: (e) => e.stopPropagation() }, cb),
        el('td', {}, el('span', { style: t.done ? 'text-decoration:line-through;color:var(--muted)' : '', text: t.title }), t.priority === 'high' ? el('span', { class: 'tag red', text: 'спешно', style: 'margin-left:8px' }) : null),
        // (Г.4) Срокът НЕ се крие на тесен екран — в картата минава на
        // втори ред. Точно той е причината да отвориш „Задачи" от телефона.
        el('td', { class: 'task-due' }, t.due_date ? el('span', { class: 'tag ' + (overdue ? 'red' : 'gray'), text: dfmt(t.due_date) }) : '—')
      ));
    };
    open.forEach(addRow); done.forEach(addRow);
    wrap.appendChild(el('table', { class: 'cards-sm' }, tb));
  }
  panel.appendChild(wrap);
  page.appendChild(panel);
}

export function taskForm(existing) {
  const t = existing || {};
  const f = {
    title: input({ value: t.title || '', placeholder: 'Какво трябва да се направи' }),
    due_date: dateInput(t.due_date),
    priority: el('select', {}, ...[['normal', 'Нормален'], ['high', 'Спешен']].map(([v, l]) => el('option', { value: v, text: l, selected: (t.priority || 'normal') === v }))),
    description: el('textarea', { placeholder: 'Детайли…' }, t.description || ''),
  };
  const body = el('div', {}, field('Задача', f.title), row(field('Срок', f.due_date), field('Приоритет', f.priority)), field('Бележки', f.description));
  const save = async () => {
    // Неразбрана дата не тръгва празна — сървърът би сложил днешна (ПРОМТ-19).
    if (!guardDates(f.due_date)) return;
    const p = { company_id: state().activeCompany };
    for (const k in f) p[k] = ('iso' in f[k].dataset) ? f[k].dataset.iso : f[k].value;
    if (existing) p.done = existing.done;
    try {
      if (existing) await api('/tasks/' + existing.id, { method: 'PUT', body: JSON.stringify(p) });
      else await api('/tasks', { method: 'POST', body: JSON.stringify(p) });
      closeModal(); toast('Записано.'); view($('#page'));
    } catch (e) { toast(e.message, true); }
  };
  const foot = el('div', {});
  if (existing && isAdminUser()) foot.appendChild(el('button', { class: 'btn sm danger', text: 'Изтрий', onClick: async () => { if (await confirmDialog('Да изтрия ли тази задача?', { okText: 'Изтрий', danger: true })) { try { await api('/tasks/' + existing.id, { method: 'DELETE' }); closeModal(); toast('Изтрито.'); view($('#page')); } catch (e) { toast('Изтриването не се получи. ' + e.message, true); } } }, style: 'margin-right:auto' }));
  foot.appendChild(el('button', { class: 'btn ghost', text: 'Отказ', onClick: closeModal }));
  foot.appendChild(el('button', { class: 'btn', text: 'Запази', onClick: save }));
  openModal({ title: existing ? 'Редакция на задача' : 'Нова задача', body, foot });
}


// Legacy мост: таблото (немигрирано) отваря формата по глобално име.
window.taskForm = taskForm;
